// Device detection utilities

export const isMobileDevice = () => {
  // Check if the user agent indicates a mobile device
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Common mobile device patterns
  const mobilePatterns = [
    /android/i,
    /webos/i,
    /iphone/i,
    /ipad/i,
    /ipod/i,
    /blackberry/i,
    /windows phone/i,
    /opera mini/i,
    /mobile/i
  ];
  
  // Check if any pattern matches
  return mobilePatterns.some(pattern => pattern.test(userAgent));
};

// Alternative check using screen size
export const isSmallScreen = () => {
  return window.innerWidth <= 768;
};

// Combined check for mobile experience
export const isMobileExperience = () => {
  return isMobileDevice() || isSmallScreen();
};